import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

// services
import { recoverDatoFiscalDeleted } from '../../Services/datoFiscalService'

// Sweet alert
import Swal from 'sweetalert2'

// router
import { withRouter } from 'react-router-dom'

const ItemDatoFiscalEliminado = ({ datoFiscal, setIsLoad }) => {
    const recoverDatoFiscal = (datoFiscal) => {
        Swal.fire({
            title: 'Estas seguro de recuperarlo?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Recuperar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para recuperar
                recoverDatoFiscalDeleted(datoFiscal.id)
                    .then((res) => {
                        Swal.fire(
                            'Recuperado!',
                            'El dato fiscal fue recuperado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{datoFiscal.id}</th>
            <td>{datoFiscal.razonSocial}</td>
            <td>{datoFiscal.domicilioFiscal}</td>
            <td>{datoFiscal.condicionFiscal.nombre}</td>
            <td>{datoFiscal.cuitCuil}</td>
            <td>{datoFiscal.apiKey}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverDatoFiscal(datoFiscal)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemDatoFiscalEliminado)
